import { ClientApp, ClientAppProps } from '@stitch-fix/sf-next';
import { getWindow, ToastProvider } from '@stitch-fix/mode-react';
import { AnimatePresence } from 'framer-motion';
import { NavigationProvider } from '../components/OnboardingNavigation/NavigationProvider';
import { FlowProvider } from '../features/lowerFixFunnel/components/FlowProvider';
// Turbopack rejects first-party global Sass imports from `_app.page.tsx`,
// so this app-wide stylesheet is loaded as a CSS Module with explicit global selectors.
import '../styles/global.module.scss';
import { isLocal } from '../utils/helpers';

// ⚠️ ⚠️ ⚠️ Before making any changes to this file, test your proposed changes in production
// via the POC application on both SSR and SSG pages

if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
  // require is synchronous, which allows MSW to be initialized before the app renders,
  // see: https://github.com/mswjs/msw/discussions/1236
  // eslint-disable-next-line global-require
  require('../mocks/msw');
}

// Allow mocking GTM in dev
if (isLocal()) {
  const win = getWindow();
  if (win && !win?.dataLayer) {
    win.dataLayer = [];
  }
}

// Report on next.js metrics and mark `app_rendered`.
// AUTOGENERATED BY SF-NEXT TO SUPPORT TRACKING PERFORMANCE ANALYTICS. DO NOT
// REMOVE.
export { reportWebVitals } from '@stitch-fix/sf-next';
const App = (props: ClientAppProps) => {
  if (props.router.pathname.startsWith('/quiz/') || props.router.pathname.startsWith('/signup') || props.router.pathname.startsWith('/add-profile')) {
    return <ToastProvider>
        <NavigationProvider>
          <AnimatePresence mode="wait" initial={false}>
            <ClientApp {...props} key={props.router.asPath} />
          </AnimatePresence>
        </NavigationProvider>
      </ToastProvider>;
  }
  if (props.router.pathname.startsWith('/onboarding/get-your-fix/')) {
    return <ToastProvider>
        <NavigationProvider>
          <FlowProvider>
            <ClientApp {...props} />
          </FlowProvider>
        </NavigationProvider>
      </ToastProvider>;
  }
  if (props.router.pathname.startsWith('/onboarding')) {
    return <ToastProvider>
        <NavigationProvider>
          <AnimatePresence mode="wait" initial={false}>
            <ClientApp {...props} key={props.router.asPath} />
          </AnimatePresence>
        </NavigationProvider>
      </ToastProvider>;
  }
  if (props.router.pathname.startsWith('/client/stylefile/quiz')) {
    return <ToastProvider>
        <NavigationProvider>
          <ClientApp {...props} />
        </NavigationProvider>
      </ToastProvider>;
  }
  return <ToastProvider>
      <ClientApp {...props} />
    </ToastProvider>;
};
export default App;